import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Space, Tabs, Layout } from 'antd';
import NoteRules from '../components/preferences/NoteRules';

const { Content } = Layout;

const Preferences = () => {
  const { t } = useTranslation();

  const items = [
    {
      key: 'note-rules',
      label: (
        <span style={{ 
          fontSize: '16px', 
          fontWeight: '600',
          color: 'rgba(0, 0, 0, 0.55)'  // Slightly lighter than default
        }}>
          {t('note_rules.title')}
        </span>
      ),
      children: <NoteRules />,
    },
  ];

  return (
    <Content className="page">
      <Tabs
        defaultActiveKey="note-rules"
        items={items}
        style={{ backgroundColor: 'white', padding: '24px', borderRadius: '8px' }}
      />
    </Content>
  );
};

export default Preferences; 